<kor-icon
  [icon]="active ? 'favorite' : 'favorite_border'"
  [color]="active ? 'deeppink' : 'unset'"
></kor-icon>
{{label}}